// https://github.com/zeit/next.js/issues/2060#issuecomment-385199026

if (typeof window !== 'undefined' && !__DEV__) {
  require('@babel/polyfill');

  // localStorage
  // https://gist.github.com/juliocesar/926500
  if (!('localStorage' in window)) {
    window.localStorage = {
      _data: {},
      setItem(id, val) { this._data[id] = String(val); return this._data[id]; },
      getItem(id) {
        return Object.prototype.hasOwnProperty.call(this._data, id) ? this._data[id] : undefined;
      },
      removeItem(id) { return delete this._data[id]; },
      clear() { this._data = {}; return this._data; },
    };
  }

  // Number.EPSILON
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/EPSILON
  if (Number.EPSILON === undefined) {
    Number.EPSILON = 2 ** -52;
  }
}
